export default "__VITE_ASSET__CBY1u_Y2__"